import { createDebug } from '@ponpon/api-client'

const aliasMiss = createDebug('dw:model-alias:miss')

/**
 * Display-only aliases that hide internal model IDs from end users on the Canvas.
 *
 * The IDs on the left ARE the values stored in YDoc and read by the backend —
 * never change them here. Backend / Director / schemas continue to use the real
 * provider names. Only the user-visible label is rewritten to a Roman god alias
 * at render time. Version numbers and variant suffixes (I2V/R2V/Pro) are kept
 * so users can still distinguish quality tiers.
 */
export const IMAGE_MODEL_ALIASES: Record<string, string> = {
  'gemini-3.1-flash-image-preview': 'Venus 3.1 Pro',
  'gemini-2.5-flash-image': 'Venus 2.5',
  'openai-gpt-image-2': 'Mars 2',
}

export const VIDEO_MODEL_ALIASES: Record<string, string> = {
  'seedance-2.0-image-to-video': 'Jupiter 2.0 I2V',
  'seedance-2.0-reference-to-video': 'Jupiter 2.0 R2V',
  'kling-v3-pro': 'Mercury 3 Pro',
  'kling-o3-pro': 'Mercury O3 Pro',
  'veo-3.1': 'Neptune 3.1',
  'happy-horse-image-to-video': 'Pegasus I2V',
  'minimax-h3': 'Lyra H3',
}

export const TTS_PROVIDER_ALIASES: Record<string, string> = {
  elevenlabs: 'Aurora',
  gemini: 'Diana',
}

export const SCRIPT_MODEL_ALIASES: Record<string, string> = {
  gemini: 'Apollo',
  claude: 'Vulcan',
  gpt: 'Saturn',
}

export const SOUND_MODEL_ALIASES: Record<string, string> = {
  elevenlabs_v3: 'Aurora V3',
}

function lookup(map: Record<string, string>, id: string, kind: string): string {
  const alias = map[id]
  if (alias) return alias
  aliasMiss('unknown %s id: %o', kind, id)
  return id
}

export function getImageModelLabel(id: string): string {
  return lookup(IMAGE_MODEL_ALIASES, id, 'image-model')
}

export function getVideoModelLabel(id: string): string {
  return lookup(VIDEO_MODEL_ALIASES, id, 'video-model')
}

export function getTtsProviderLabel(id: string): string {
  return lookup(TTS_PROVIDER_ALIASES, id, 'tts-provider')
}

export function getScriptModelLabel(id: string): string {
  return lookup(SCRIPT_MODEL_ALIASES, id, 'script-model')
}

export function getSoundModelLabel(id: string): string {
  return lookup(SOUND_MODEL_ALIASES, id, 'sound-model')
}
